import { CustomerDeliveryItemMessage, ItemMessage } from '@/b2c/shared/api/server-apis';
import { computed, Ref, ref } from 'vue';

const messages: Ref<CustomerDeliveryItemMessage[]> = ref([]);

export function useCustomerDeliveryMessages(lineItemId?: number) {
    function setMessages(deliveryMessages: CustomerDeliveryItemMessage[]) {
        messages.value = deliveryMessages;
    }

    const deliveryMessage = computed<ItemMessage[]>(() => {
        const msg = messages.value.find(msg => msg.itemId === lineItemId);
        return msg ? [msg.itemMessage] : [];
    });

    return {
        deliveryMessage,
        setMessages,
    };
}
